import * as EditorUtils from '../Utils/editorjs/utils'

window.EditorUtils = EditorUtils
